import request, { IServerResponse } from '@/utils/request';
import { ListCommenReq, MessageRes } from './define';

export const getMessageList = (params: ListCommenReq): Promise<IServerResponse<MessageRes>> =>
    request.get('/api/message/list', params);
